import React from 'react';

const Blogs = () => {
    return (
        <div style={{ minHeight: '100vh' }} className='container'>
            <h2 className='text-center mt-5 mb-3'><span style={{ backgroundColor: 'lightgray' }} className='py-2 px-5'>Coming Soon...</span></h2>
            
        </div>
    );
};

export default Blogs;